<template>
  <div class="scadnow">
    <div class="banner">
      <img src="@/assets/images/newlocations/scadnow/banner.jpg" class="w100" />
    </div>

    <div class="cust-content">
      <div class="head-info" v-if="$i18n.locale === 'en'">
        <div class="head-title">
          SCADnow — learn anytime, anywhere with a world-class creative
          education
        </div>
        <div class="head-desc">
          SCADnow brings the university’s award-winning creative education
          online — blending live classes, flexible schedules, and real-world
          collaboration with global companies.
        </div>
        <div class="head-tags">
          <span class="head-tag">20+ years of online excellence</span>
          <span class="head-tag">99% graduate success</span>
          <span class="head-tag"
            >Projects with Google, Lenovo, and Marchon</span
          >
        </div>
      </div>

      <div class="head-info" v-if="$i18n.locale === 'zh'">
        <div class="head-title">SCADnow — 随时随地学习，畅享世界级创意教育</div>
        <div class="head-desc">
          SCADnow
          将屡获殊荣的创意教育带入线上课堂，融合实时授课、灵活时间安排与全球企业项目合作，让学习突破地域限制。
        </div>
        <div class="head-tags">
          <span class="head-tag">20+ 年在线教学经验</span>
          <span class="head-tag">99% 毕业就业与升学率</span>
          <span class="head-tag">项目合作：谷歌、联想、Marchon</span>
        </div>
      </div>
      <div class="locationMenu">
        <div class="grid-content">
          <div class="locationMenuList">
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'Atlanta' ? 'active' : ''"
              @click="locationMenuItemClick('Atlanta')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_01.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">A</div>
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'en'">Atlanta</div>
                <div class="nav-name" v-if="$i18n.locale === 'zh'">
                  亚特兰大
                </div>
              </div>
            </div>
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'Lacoste' ? 'active' : ''"
              @click="locationMenuItemClick('Lacoste')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_02.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">L</div>
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'en'">Lacoste</div>
                <div class="nav-name" v-if="$i18n.locale === 'zh'">
                  拉科斯特
                </div>
              </div>
            </div>
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'Savannah' ? 'active' : ''"
              @click="locationMenuItemClick('Savannah')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_03.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">S</div>
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'en'">
                  Savannah
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'zh'">萨凡纳</div>
              </div>
            </div>
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'SCADnow' ? 'active' : ''"
              @click="locationMenuItemClick('SCADnow')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_04.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">e</div>
                </div>
                <div class="nav-name">SCADnow</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="video-box">
      <video
        src="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20260929/2026-27_SCADnow_SCN_Burned-Captions-GFX_Approved_260925.mp4"
        controls
        poster="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20260929/2026-27_SCADnow_SCN_Burned-Captions-GFX_Approved_260925.mp4?x-oss-process=video/snapshot,t_1000"
      ></video>
    </div>

    <div class="cust-content">
      <div v-if="$i18n.locale === 'en'">
        <div class="grid-content content">
          <el-row class="why-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="11" class="vertical-center">
              <div class="content-title">Why SCADnow</div>
              <div
                class="text flex-align-items-center"
                style="margin-top: 40px"
              >
                <div>
                  For the artist, designer, and professional on the go, SCADnow
                  delivers real-time and on-demand learning with the same
                  curriculum, faculty, and outcomes as on-campus programs.
                </div>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://www.scadedu.cn/Academic/"
                  >Explore SCADnow degree programs</a
                >
              </div>
            </el-col>

            <el-col :xs="24" :md="13">
              <img
                src="@/assets/images/newlocations/scadnow/04why/01.jpg"
                class="w100"
              />
            </el-col>
          </el-row>

          <!--          <div class="building-box">-->
          <!--            <div-->
          <!--              class="-->
          <!--                building-banner-swiper-container-->
          <!--                swiper-container-->
          <!--                location-banner-->
          <!--              "-->
          <!--            >-->
          <!--              <div class="swiper-wrapper">-->
          <!--                <div-->
          <!--                  class="swiper-slide"-->
          <!--                  v-for="(banner, index) in $i18n.locale === 'zh'-->
          <!--                    ? buildingCnBanners-->
          <!--                    : buildingEnBanners"-->
          <!--                  :key="index"-->
          <!--                >-->
          <!--                  <div class="slide-inner">-->
          <!--                    <img :src="banner.src" alt="" />-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div class="swiper-pagination"></div>-->
          <!--              <img-->
          <!--                class="button-prev"-->
          <!--                src="@/assets/images/newlocations/img_01.png"-->
          <!--                style="-->
          <!--                  position: absolute;-->
          <!--                  top: 50%;-->
          <!--                  left: 30px;-->
          <!--                  z-index: 999999;-->
          <!--                "-->
          <!--              />-->

          <!--              <img-->
          <!--                class="button-next"-->
          <!--                src="@/assets/images/newlocations/img_02.png"-->
          <!--                style="-->
          <!--                  position: absolute;-->
          <!--                  top: 50%;-->
          <!--                  right: 30px;-->
          <!--                  z-index: 999999;-->
          <!--                "-->
          <!--              />-->
          <!--            </div>-->
          <!--          </div>-->

          <el-row class="climate-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="13">
              <img
                src="@/assets/images/newlocations/scadnow/05learning/swiper_01.jpg"
                class="w100"
              />
            </el-col>

            <el-col :xs="24" :md="11" class="climate-content vertical-center">
              <div class="content-title">Learning experience</div>
              <div
                class="text flex-align-items-center"
                style="margin-top: 40px"
              >
                <div>
                  Live virtual classes via Zoom, plus recorded sessions for
                  flexible review. Interactive discussions, design critiques,
                  and cross-time-zone collaboration make learning immersive.
                </div>
                <a
                  target="_blank"
                  class="link-more"
                  style="margin-top: 30px"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >Chat with admission</a
                >
              </div>
            </el-col>
          </el-row>

          <el-row
            class="margin-top career-box"
            style="margin-top: 60px"
            :gutter="30"
          >
            <el-col :xs="24" :md="11">
              <div class="content-title">Career pathways</div>
              <div class="text" style="margin-top: 30px">
                SCADnow students join
                <a
                  href="https://www.scad.edu/about/industry-partnerships/scadpro"
                  target="_blank"
                  >SCADpro</a
                >
                digital collaborations with global companies like Google and
                <a href="https://www.marchon.com/" target="_blank">Marchon</a>,
                gaining real-world experience while studying online.
              </div>
              <div class="tags">
                <a
                  href="https://www.scadedu.cn/Programs/14/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%8A%A8%E7%94%BB.html"
                  class="tag"
                  target="_blank"
                  >Animation</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/45/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%B9%B3%E9%9D%A2%E8%AE%BE%E8%AE%A1%E4%B8%8E%E8%A7%86%E8%A7%89%E4%BC%A0%E8%BE%BE.html"
                  class="tag"
                  target="_blank"
                  >Illustration</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/56/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E4%BA%92%E5%8A%A8%E8%AE%BE%E8%AE%A1%E4%B8%8E%E6%B8%B8%E6%88%8F%E5%BC%80%E5%8F%91.html"
                  class="tag"
                  target="_blank"
                  >Interative design and game development</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/31/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E6%97%B6%E8%A3%85.html"
                  class="tag"
                  target="_blank"
                  >Fashion</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/101/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E8%A7%86%E8%A7%89%E7%89%B9%E6%95%88.html"
                  class="tag"
                  target="_blank"
                  >Visual effects</a
                >
              </div>
            </el-col>

            <!--            <el-col :xs="24" :md="13">-->
            <!--              <div-->
            <!--                class="-->
            <!--                  career-banner-swiper-container-->
            <!--                  swiper-container-->
            <!--                  location-banner-->
            <!--                "-->
            <!--              >-->
            <!--                <div class="swiper-wrapper">-->
            <!--                  <div-->
            <!--                    class="swiper-slide"-->
            <!--                    v-for="(banner, index) in careerCnBanners"-->
            <!--                    :key="index"-->
            <!--                  >-->
            <!--                    <div class="slide-inner">-->
            <!--                      <img :src="banner.src" alt="" />-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->

            <!--                <div class="swiper-pagination"></div>-->
            <!--                <img-->
            <!--                  class="button-prev"-->
            <!--                  src="@/assets/images/newlocations/img_01.png"-->
            <!--                  style="-->
            <!--                    position: absolute;-->
            <!--                    top: 50%;-->
            <!--                    left: 30px;-->
            <!--                    z-index: 999999;-->
            <!--                  "-->
            <!--                />-->

            <!--                <img-->
            <!--                  class="button-next"-->
            <!--                  src="@/assets/images/newlocations/img_02.png"-->
            <!--                  style="-->
            <!--                    position: absolute;-->
            <!--                    top: 50%;-->
            <!--                    right: 30px;-->
            <!--                    z-index: 999999;-->
            <!--                  "-->
            <!--                />-->
            <!--              </div>-->
            <!--            </el-col>-->

            <el-col :xs="24" :md="13">
              <img
                src="@/assets/images/newlocations/scadnow/06career/01.jpg"
                class="w100"
              />
            </el-col>
          </el-row>

          <div class="life_community-box">
            <div class="content-title">Access and tools</div>
            <div class="text">
              Access professional-grade software like Adobe Creative Cloud,
              Autodesk Maya, and Unity 3D. Use
              <a
                href="https://www.scad.edu/academics/beyond-classroom/scadamp"
                target="_blank"
                >SCADamp</a
              >
              for career communication coaching
            </div>

            <div
              class="
                lifeCommunity-banner-swiper-container
                swiper-container
                location-banner
              "
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in lifeCommunityCnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row class="recognition-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="13">
              <img
                class="w100"
                src="@/assets/images/newlocations/scadnow/08community/01.jpg"
              />
            </el-col>

            <el-col :xs="24" :md="11" class="vertical-center">
              <div class="content-title nowtitle">Community and support</div>
              <div class="text" style="margin-top: 40px">
                SCADnow students enjoy the same global network — academic
                advising, career support, and virtual wellness resources through
                <a
                  href="https://www.scad.edu/life/international-student-life/international-student-resources"
                  target="_blank"
                  >ISSO</a
                >
                and
                <a
                  href="https://www.scad.edu/life/health-and-wellness"
                  target="_blank"
                  >Bee Well</a
                >.
              </div>
            </el-col>
          </el-row>

          <el-row class="recognition-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="11" class="vertical-center">
              <div class="content-title">Recognition</div>

              <div class="text" style="margin-top: 40px">
                <ul style="margin-top: 5px">
                  <li>MUSE Innovation Award (Gold)</li>
                  <li>Online Learning Consortium Excellence Award</li>
                  <li>US Distance Learning Catalyst Award</li>
                </ul>
              </div>
            </el-col>

            <el-col :xs="24" :md="13">
              <img
                class="w100"
                src="@/assets/images/newlocations/scadnow/09recognition/01.jpg"
              />
            </el-col>
          </el-row>

          <el-row class="support-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="24" class="vertical-center">
              <div class="content-title">Plan your SCADnow experience</div>
              <div class="text">
                <div class="support-title">
                  Are SCADnow degrees the same as on-campus degrees?
                </div>
                <div class="support-text">
                  Yes, SCADnow degrees are the same curriculum, faculty, and
                  degree recognition.
                </div>
                <div class="line"></div>

                <div class="support-title">
                  Can I combine online and on-campus study?
                </div>
                <div class="support-text">
                  Yes, many students take hybrid paths between SCADnow and
                  campus locations.
                </div>
                <div class="line"></div>
                <div class="support-title">What’s needed to start?</div>
                <div class="support-text">
                  Submit your application online. Once accepted, all you need is
                  a laptop, a stable internet connection, and creativity — SCAD
                  provides the rest.
                </div>
                <div class="line"></div>
              </div>
            </el-col>
          </el-row>

          <el-row class="scad-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="16">
              <div class="content-title">Start your SCAD journey</div>
              <div class="text">
                Click the 'Chat with Admission' to request program information
                or book a 1:1 consultation with a SCAD admission adviser. Our
                team responds in 2 business days with your Chinese info pack
                (program list + timeline).
              </div>
            </el-col>

            <el-col :xs="24" :md="8" class="vertical-center2">
              <div class="text">
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >Chat with admission</a
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div v-if="$i18n.locale === 'zh'">
        <div class="grid-content content">
          <el-row class="why-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="11" class="vertical-center">
              <div class="content-title">为什么选择 SCADnow</div>
              <div
                class="text flex-align-items-center"
                style="margin-top: 40px"
              >
                <div>
                  无论你是艺术家、设计师，还是创意领域的专业人士，SCADnow
                  提供与线下校区相同的课程、实时课堂、灵活安排，同样的课程、导师与成果，让你实现实时
                  + 随选学习的双重灵活性。
                </div>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://www.scadedu.cn/Academic/"
                  >探索 SCADnow 课程</a
                >
              </div>
            </el-col>

            <el-col :xs="24" :md="13">
              <img
                src="@/assets/images/newlocations/scadnow/04why/01.jpg"
                class="w100"
              />
            </el-col>
          </el-row>

          <!--          <div class="building-box">-->
          <!--            <div-->
          <!--              class="-->
          <!--                building-banner-swiper-container-->
          <!--                swiper-container-->
          <!--                location-banner-->
          <!--              "-->
          <!--            >-->
          <!--              <div class="swiper-wrapper">-->
          <!--                <div-->
          <!--                  class="swiper-slide"-->
          <!--                  v-for="(banner, index) in $i18n.locale === 'zh'-->
          <!--                    ? buildingCnBanners-->
          <!--                    : buildingEnBanners"-->
          <!--                  :key="index"-->
          <!--                >-->
          <!--                  <div class="slide-inner">-->
          <!--                    <img :src="banner.src" alt="" />-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div class="swiper-pagination"></div>-->
          <!--              <img-->
          <!--                class="button-prev"-->
          <!--                src="@/assets/images/newlocations/img_01.png"-->
          <!--                style="-->
          <!--                  position: absolute;-->
          <!--                  top: 50%;-->
          <!--                  left: 30px;-->
          <!--                  z-index: 999999;-->
          <!--                "-->
          <!--              />-->

          <!--              <img-->
          <!--                class="button-next"-->
          <!--                src="@/assets/images/newlocations/img_02.png"-->
          <!--                style="-->
          <!--                  position: absolute;-->
          <!--                  top: 50%;-->
          <!--                  right: 30px;-->
          <!--                  z-index: 999999;-->
          <!--                "-->
          <!--              />-->
          <!--            </div>-->
          <!--          </div>-->

          <el-row class="climate-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="13">
              <img
                src="@/assets/images/newlocations/scadnow/05learning/swiper_01.jpg"
                class="w100"
              />
            </el-col>

            <el-col :xs="24" :md="11" class="climate-content vertical-center">
              <div class="content-title">学习体验</div>
              <div
                class="text flex-align-items-center"
                style="margin-top: 40px"
              >
                <div>
                  课程通过 Zoom
                  实时授课，并提供录播内容便于回看。学生跨时区参与互动讨论、作品评审与团队协作，沉浸式学习体验不受地域限制。
                </div>
                <a
                  target="_blank"
                  class="link-more"
                  style="margin-top: 30px"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >预约专属 SCAD 招生官咨询</a
                >
              </div>
            </el-col>
          </el-row>

          <el-row
            class="margin-top career-box"
            style="margin-top: 60px"
            :gutter="30"
          >
            <el-col :xs="24" :md="11">
              <div class="content-title">职业方向</div>
              <div class="text" style="margin-top: 30px">
                SCADnow 学生通过 SCADpro 数字协作平台，与谷歌、Marchon
                等国际企业合作，在学习过程中积累真实行业经验。
              </div>
              <div class="tags">
                <a
                  href="https://www.scadedu.cn/Programs/14/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%8A%A8%E7%94%BB.html"
                  class="tag"
                  target="_blank"
                  >动画</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/45/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%B9%B3%E9%9D%A2%E8%AE%BE%E8%AE%A1%E4%B8%8E%E8%A7%86%E8%A7%89%E4%BC%A0%E8%BE%BE.html"
                  class="tag"
                  target="_blank"
                  >插画</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/56/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E4%BA%92%E5%8A%A8%E8%AE%BE%E8%AE%A1%E4%B8%8E%E6%B8%B8%E6%88%8F%E5%BC%80%E5%8F%91.html"
                  class="tag"
                  target="_blank"
                  >交互设计与游戏开发</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/31/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E6%97%B6%E8%A3%85.html"
                  class="tag"
                  target="_blank"
                  >服装设计</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/101/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E8%A7%86%E8%A7%89%E7%89%B9%E6%95%88.html"
                  class="tag"
                  target="_blank"
                  >视觉特效</a
                >
              </div>
            </el-col>

            <!--            <el-col :xs="24" :md="13">-->
            <!--              <div-->
            <!--                class="-->
            <!--                  career-banner-swiper-container-->
            <!--                  swiper-container-->
            <!--                  location-banner-->
            <!--                "-->
            <!--              >-->
            <!--                <div class="swiper-wrapper">-->
            <!--                  <div-->
            <!--                    class="swiper-slide"-->
            <!--                    v-for="(banner, index) in careerCnBanners"-->
            <!--                    :key="index"-->
            <!--                  >-->
            <!--                    <div class="slide-inner">-->
            <!--                      <img :src="banner.src" alt="" />-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->

            <!--                <div class="swiper-pagination"></div>-->
            <!--                <img-->
            <!--                  class="button-prev"-->
            <!--                  src="@/assets/images/newlocations/img_01.png"-->
            <!--                  style="-->
            <!--                    position: absolute;-->
            <!--                    top: 50%;-->
            <!--                    left: 30px;-->
            <!--                    z-index: 999999;-->
            <!--                  "-->
            <!--                />-->

            <!--                <img-->
            <!--                  class="button-next"-->
            <!--                  src="@/assets/images/newlocations/img_02.png"-->
            <!--                  style="-->
            <!--                    position: absolute;-->
            <!--                    top: 50%;-->
            <!--                    right: 30px;-->
            <!--                    z-index: 999999;-->
            <!--                  "-->
            <!--                />-->
            <!--              </div>-->
            <!--            </el-col>-->

            <el-col :xs="24" :md="13">
              <img
                src="@/assets/images/newlocations/scadnow/06career/01.jpg"
                class="w100"
              />
            </el-col>
          </el-row>

          <div class="life_community-box">
            <div class="content-title">学习资源与工具</div>
            <div class="text">
              在线获取 Adobe Creative Cloud、Autodesk Maya、Unity 3D
              等专业级行业工具，并通过
              <a
                href="https://www.scad.edu/academics/beyond-classroom/scadamp"
                target="_blank"
                >SCADamp</a
              >
              平台提升职业沟通与表达能力
            </div>

            <div
              class="
                lifeCommunity-banner-swiper-container
                swiper-container
                location-banner
              "
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in lifeCommunityCnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row class="support-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="13">
              <img
                class="w100"
                src="@/assets/images/newlocations/scadnow/08community/01.jpg"
              />
            </el-col>

            <el-col :xs="24" :md="11" class="vertical-center">
              <div class="content-title">社区与支持</div>
              <div class="text" style="margin-top: 40px">
                SCADnow 学生同样享受全球资源支持：学业与职业指导、<a
                  href="https://www.scad.edu/life/health-and-wellness"
                  target="_blank"
                  >健康支持</a
                >与<a
                  href="https://www.scad.edu/life/international-student-life/international-student-resources"
                  >国际学生服务（ISSO）</a
                >，让你无论身在何处都能与 SCAD 社区保持紧密连接。
              </div>
            </el-col>
          </el-row>

          <el-row class="recognition-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="11" class="vertical-center">
              <div class="content-title">院校荣誉</div>
              <div class="text" style="margin-top: 40px">
                <ul style="margin-top: 5px">
                  <li>MUSE 创意奖金奖</li>
                  <li>
                    在线学习联盟卓越奖（Online Learning Consortium Excellence
                    Award）
                  </li>
                  <li>
                    美国远程教育协会创新奖（U.S. Distance Learning Catalyst
                    Award）
                  </li>
                </ul>
              </div>
            </el-col>

            <el-col :xs="24" :md="13">
              <img
                class="w100"
                src="@/assets/images/newlocations/scadnow/09recognition/01.jpg"
              />
            </el-col>
          </el-row>

          <el-row class="support-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="24" class="vertical-center">
              <div class="content-title">规划你的 SCADnow 学习体验</div>
              <div class="text">
                <div class="support-title">
                  SCADnow 的学位是否与其他校区学位相同？
                </div>
                <div class="support-text">
                  是的。SCADnow
                  所授予的学位与校内课程完全一致——相同的课程体系、师资团队、教学资源、荣誉学位。
                </div>
                <div class="line"></div>

                <div class="support-title">能否线上线下混合学习？</div>
                <div class="support-text">
                  可以。许多学生选择 SCADnow 与线下校区课程灵活结合。
                </div>
                <div class="line"></div>
                <div class="support-title">开始学习需要准备什么？</div>
                <div class="support-text">
                  在线提交申请。录取后，你只需准备电脑、稳定的网络和创意，其他一切由
                  SCAD 提供。
                </div>
                <div class="line"></div>
              </div>
            </el-col>
          </el-row>

          <el-row class="scad-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="16">
              <div class="content-title">开启你的 SCAD 之旅</div>
              <div class="text">
                填写表单即可获取课程资料，或预约与 SCAD 招生官一对一交流。<br />
                招生团队将在 2
                个工作日内回复，并发送中文资料包（含学位课程清单与申请时间线）。
              </div>
            </el-col>

            <el-col :xs="24" :md="8" class="vertical-center2">
              <div class="text">
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >预约专属 SCAD 招生官咨询</a
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min.js";
import "swiper/swiper-bundle.min.css";

export default {
  data: function () {
    return {
      selectedMenu: "atlanta",
      // buildingCnBanners: [
      //   {
      //     src: require("@/assets/images/newlocations/scadnow/05building/cn/swiper_01.jpg"),
      //     url: "",
      //   },
      //   {
      //     src: require("@/assets/images/newlocations/scadnow/05building/cn/swiper_02.jpg"),
      //     url: "",
      //   },
      //   {
      //     src: require("@/assets/images/newlocations/scadnow/05building/cn/swiper_03.jpg"),
      //     url: "",
      //   },
      //   {
      //     src: require("@/assets/images/newlocations/scadnow/05building/cn/swiper_04.jpg"),
      //     url: "",
      //   },
      //   {
      //     src: require("@/assets/images/newlocations/scadnow/05building/cn/swiper_05.jpg"),
      //     url: "",
      //   },
      //   {
      //     src: require("@/assets/images/newlocations/scadnow/05building/cn/swiper_06.jpg"),
      //     url: "",
      //   },
      // ],
      // buildingEnBanners: [
      //   {
      //     src: require("@/assets/images/newlocations/scadnow/05building/cn/swiper_01.jpg"),
      //     url: "",
      //   },
      //   {
      //     src: require("@/assets/images/newlocations/scadnow/05building/cn/swiper_02.jpg"),
      //     url: "",
      //   },
      //   {
      //     src: require("@/assets/images/newlocations/scadnow/05building/cn/swiper_03.jpg"),
      //     url: "",
      //   },
      //   {
      //     src: require("@/assets/images/newlocations/scadnow/05building/cn/swiper_04.jpg"),
      //     url: "",
      //   },
      //   {
      //     src: require("@/assets/images/newlocations/scadnow/05building/cn/swiper_05.jpg"),
      //     url: "",
      //   },
      //   {
      //     src: require("@/assets/images/newlocations/scadnow/05building/cn/swiper_06.jpg"),
      //     url: "",
      //   },
      // ],

      careerCnBanners: [
        {
          src: require("@/assets/images/newlocations/scadnow/06career/01.jpg"),
          url: "",
        },
      ],
      lifeCommunityCnBanners: [
        {
          src: require("@/assets/images/newlocations/scadnow/07tools/01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/scadnow/07tools/02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/scadnow/07tools/03.jpg"),
          url: "",
        },
      ],
    };
  },
  mounted() {
    // this.selectedMenu = this.$route.params["name"];
    // var query = this.$route.query;
    // if (query.l) {
    //   this.selectedMenu = query.l;
    // }

    this.selectedMenu = this.$route.fullPath.substring(
      this.$route.fullPath.lastIndexOf("/") + 1
    );

    this.mySwiper = this.initSwiper(".building-banner-swiper-container");
    this.careerSwiper = this.initSwiper(".career-banner-swiper-container");
    this.careerSwiper = this.initSwiper(
      ".lifeCommunity-banner-swiper-container"
    );
  },
  methods: {
    locationMenuItemClick(menu) {
      // this.selectedMenu = menu;
      // this.goTop();
      window.location.href = menu;
    },
    initSwiper: function (clazz) {
      var swiperOptions = {
        loop: true,
        speed: 1000,
        autoplay: true,
        grabCursor: true,
        autoHeight: true,
        watchSlidesProgress: true,
        mousewheelControl: true,
        keyboardControl: true,
        observer: true,

        pagination: {
          el: clazz + " .swiper-pagination",
        },
        navigation: {
          nextEl: clazz + " .button-next",
          prevEl: clazz + " .button-prev",
        },
        on: {},
      };

      return new Swiper(clazz, swiperOptions);
    },
  },
};
</script>

<style scoped lang="less">
@import "../../locations.less";
</style>
